"use client";

import React, { useState, useEffect } from 'react';
import Image from "next/image";
import { useRouter } from "next/navigation";
import { formatarData } from "@/lib/utils";
import CardNewsMedium from '@/components/molecules/CardNewsMedium';
import { Modal } from '@/components/atoms/modal';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/atoms/carousel";

interface NoticiaDetalheClientProps {
  noticiaData: {
    documentId?: string;
    title?: string;
    description?: string;
    publishedAt?: string;
    Tag?: string;
    image?: {
      url?: string;
      alternativeText?: string;
    };
    cms_tema_noticia?: {
      label?: string;
    };
    galeria?: {
      url?: string;
      alternativeText?: string;
    }[];
    slug?: string;
  } | null;
  error: string | null;
  outrasNoticias?: any[];
  todasNoticiasNavegacao?: any[];
  titleGaleria?: string;
  titleOutrasNoticias?: string;
}

const NoticiaDetalheClient: React.FC<NoticiaDetalheClientProps> = ({
  noticiaData,
  error,
  outrasNoticias = [],
  todasNoticiasNavegacao = [],
  titleGaleria,
  titleOutrasNoticias,
}) => {
  const router = useRouter();
  const [isGalleryModalOpen, setIsGalleryModalOpen] = useState(false);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [imageLoadingStates, setImageLoadingStates] = useState<{ [key: number]: boolean }>({});

  // Preparar dados da galeria para uso
  const galeriaImages = Array.isArray(noticiaData?.galeria)
    ? noticiaData.galeria
      .filter((img): img is { url: string; alternativeText?: string } =>
        typeof img?.url === 'string' && !!img.url
      )
      .map(img => ({
        url: img.url,
        alt: img.alternativeText || 'Imagem da galeria'
      }))
    : [];

  const openGalleryModal = (index: number = 0) => {
    setSelectedImageIndex(index);
    setIsGalleryModalOpen(true);
  };

  const closeGalleryModal = () => {
    setIsGalleryModalOpen(false);
    setSelectedImageIndex(0);
  };

  const handleImageLoad = (index: number) => {
    setImageLoadingStates(prev => ({ ...prev, [index]: false }));
  };



  // Navegação por teclado no modal
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (!isGalleryModalOpen) return;

      switch (event.key) {
        case 'ArrowLeft':
          event.preventDefault();
          setSelectedImageIndex(prev =>
            prev > 0 ? prev - 1 : galeriaImages.length - 1
          );
          break;
        case 'ArrowRight':
          event.preventDefault();
          setSelectedImageIndex(prev =>
            prev < galeriaImages.length - 1 ? prev + 1 : 0
          );
          break;
        case 'Escape':
          event.preventDefault();
          closeGalleryModal();
          break;
      }
    };

    if (isGalleryModalOpen) {
      document.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isGalleryModalOpen, galeriaImages.length]);

  if (!noticiaData) {
    return (
      <div className="flex justify-center items-center min-h-[400px]">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-blue-400 border-t-blue-600 rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600 text-lg">Carregando detalhes da notícia...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[300px] py-12">
        <div className="bg-red-50 border border-red-200 rounded-lg p-6 max-w-xl mx-auto">
          <h3 className="text-red-700 text-xl font-semibold mb-2">Erro ao carregar notícia</h3>
          <p className="text-red-600 mb-4">{error}</p>
          <p className="text-gray-600 mb-6">A notícia solicitada não foi encontrada ou ocorreu um erro ao carregar seus detalhes.</p>
          <button
            onClick={() => router.push('/noticias-eventos')}
            className="mt-6 px-6 py-2 bg-blue-600 text-white rounded-full hover:bg-blue-700 transition-colors"
          >
            Ver todas as notícias
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 sm:px-6 lg:px-8 pb-24 ">
      <div className="grid grid-cols-1 xl:grid-cols-12 gap-6 lg:gap-4">
        {/* Meta, categoria e título */}
        <div className="xl:col-span-8 xl:offset-0">
          <div className="flex flex-col gap-3 md:gap-4 lg:mt-10">
            {/* Título */}
           {/*  <h1 className="text-[#2A2A2A] text-2xl md:text-3xl lg:text-4xl font-medium font-exo-2 leading-tight mb-8">
              {noticiaData.title}
            </h1> */}

            {/* Data de publicação */}
          

           

          </div>
        </div>
        {/* Conteúdo principal */}
        <div className="xl:col-span-8 order-2">

          <div className='pt-0'>
            {/* Topo com imagem à esquerda e meta/título à direita */}
            <div className="grid grid-cols-1">
              {/* Imagem principal */}
              <div>
                {(() => {
                  const mainImgUrl = (noticiaData as any)?.image?.url || (noticiaData as any)?.Image?.url
                  const mainImgAlt = (noticiaData as any)?.image?.alternativeText || (noticiaData as any)?.Image?.alternativeText || noticiaData.title || "Imagem da notícia"
                  return mainImgUrl ? (
                    <div className="relative w-full min-h-[482px]  rounded-xl overflow-hidden">
                      <Image
                        src={mainImgUrl}
                        alt={mainImgAlt}
                        fill
                        className="object-cover rounded-xl object-center-bottom"
                        priority
                      />
                    </div>
                  ) : null
                })()}
              </div>


            </div>

            {/* Descrição abaixo do bloco superior */}
            <div
              className="prose html-content prose-sm sm:prose-base lg:prose-lg max-w-none text-justify  font-light font-poppins leading-relaxed sm:leading-loose mt-6"
              dangerouslySetInnerHTML={{ __html: noticiaData.description || "" }}
            />
          </div>
        </div>

        {/* Sidebar - Outras notícias (visível apenas no desktop) */}
        <div className="xl:col-span-4 order-2 hidden xl:block mt-0">
          <div className="">
            {/* Título da seção */}
            {titleOutrasNoticias && (
              <h2 className="text-zinc-800 text-4xl font-medium font-['Barlow_Semi_Condensed'] uppercase leading-[54px] mb-8 flex text-right justify-end">
                {titleOutrasNoticias}
              </h2>
            )}

            <div className="space-y-4 sm:space-y-4">
              {outrasNoticias.length > 0 ? (
                outrasNoticias
                  .filter((n: any) => n.documentId !== noticiaData?.documentId) // Remove a notícia atual da sidebar
                  .slice(0, 3)
                  .map((noticia: any) => {
                    const link = `/noticias-eventos/noticias/${noticia.slug}`
                    const image = (noticia?.image?.url) || (noticia?.Image?.url) || noticia.imgUrl
                    const title = noticia.title || noticia.titulo
                    const date = formatarData(noticia.data || '')

                    return (
                      <CardNewsMedium
                        key={noticia.documentId}
                        image={image}
                        title={title}
                        date={date}
                        link={link}
                        onClick={() => (window.location.href = link)}
                      />
                    )
                  })
              ) : (
                <p className="text-gray-500 text-center py-8">Não há outras notícias disponíveis no momento.</p>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Galeria de fotos - Carousel */}
      {galeriaImages.length > 0 && (
        <div className="mt-12 sm:mt-16 lg:mt-20">
          <div className="flex items-center justify-between mb-6 sm:mb-8 lg:mb-10">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold text-left font-exo-2">
              {titleGaleria || 'Galeria de Fotos'}
            </h2>
            <span className="text-sm text-gray-500 bg-gray-100 px-3 py-1 rounded-full">
              {galeriaImages.length} {galeriaImages.length === 1 ? 'foto' : 'fotos'}
            </span>
          </div>

          <Carousel className="w-full">
            <CarouselContent className="gap-4">
              {galeriaImages.map((image, index) => (
                <CarouselItem
                  key={index}
                  className={
                    index === 0
                      ? 'basis-auto shrink-0'
                      : 'basis-auto shrink-0'
                  }
                >
                  <button
                    type="button"
                    onClick={() => openGalleryModal(index)}
                    className={
                      index % 2 === 0
                        ? 'group block w-[85vw] sm:w-[75vw] md:w-[65vw] lg:w-[460px] h-56 sm:h-64 md:h-72 lg:h-80 rounded-xl overflow-hidden bg-gray-50 hover:shadow-lg transition'
                        : 'group block w-[65vw] sm:w-[55vw] md:w-[45vw] lg:w-56 h-40 sm:h-48 md:h-56 lg:h-80 rounded-xl overflow-hidden bg-gray-50 hover:shadow-lg transition'
                    }
                    aria-label={`Ver imagem ${index + 1} de ${galeriaImages.length}: ${image.alt}`}
                    title={`Clique para ampliar - ${image.alt}`}
                  >
                    <div className="relative w-full h-full">
                      {imageLoadingStates[index] && (
                        <div className="absolute inset-0 bg-gray-200 animate-pulse" />
                      )}
                      <Image
                        src={image.url}
                        alt={image.alt}
                        fill
                        className="object-cover"
                        onLoadingComplete={() => handleImageLoad(index)}
                      />
                    </div>
                  </button>
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious className="-left-3 top-1/2 -translate-y-1/2" aria-label="Anterior" />
            <CarouselNext className="-right-3 top-1/2 -translate-y-1/2" aria-label="Seguinte" />
          </Carousel>
        </div>
      )}

      {/* Outras notícias - Mobile e Tablet (abaixo da galeria) */}
      <div className="xl:hidden mt-12 sm:mt-16 lg:mt-20">
        <div className="rounded-lg p-4 sm:p-6 lg:p-8">
          {/* Título da seção */}
          {titleOutrasNoticias && (
            <h2 className="text-xl sm:text-2xl font-bold font-barlow text-gray-900 mb-6 uppercase text-center">
              {titleOutrasNoticias}
            </h2>
          )}

          {outrasNoticias.length > 0 ? (
            <>
              {/* Mobile: Carousel */}
              <div className="md:hidden">
                <Carousel className="w-full">
                  <CarouselContent>
                    {outrasNoticias
                      .filter((n: any) => n.documentId !== noticiaData?.documentId) // Remove a notícia atual
                      .map((noticia: any) => {
                        const link = `/noticias-eventos/noticias/${noticia.slug}`
                        const image = (noticia?.image?.url) || (noticia?.Image?.url) || noticia.imgUrl
                        const title = noticia.title || noticia.titulo
                        const date = formatarData(noticia.data || '')

                        return (
                          <CarouselItem key={noticia.documentId}>
                            <div className="px-2">
                              <CardNewsMedium
                                image={image}
                                title={title}
                                date={date}
                                link={link}
                                onClick={() => (window.location.href = link)}
                              />
                            </div>
                          </CarouselItem>
                        )
                      })}
                  </CarouselContent>
                </Carousel>
              </div>

              {/* Tablet: List */}
              <div className="hidden md:block space-y-4 sm:space-y-6">
                {outrasNoticias
                  .filter((n: any) => n.documentId !== noticiaData?.documentId) // Remove a notícia atual
                  .map((noticia: any) => {
                    const link = `/noticias-eventos/noticias/${noticia.slug}`
                    const image = (noticia?.image?.url) || (noticia?.Image?.url) || noticia.imgUrl
                    const title = noticia.title || noticia.titulo
                    const date = formatarData(noticia.data || '')

                    return (
                      <CardNewsMedium
                        key={noticia.documentId}
                        image={image}
                        title={title}
                        date={date}
                        link={link}
                        onClick={() => (window.location.href = link)}
                      />
                    )
                  })}
              </div>
            </>
          ) : (
            <p className="text-gray-500 text-center py-8">Não há outras notícias disponíveis no momento.</p>
          )}
        </div>
      </div>

      {/* Modal da galeria com melhorias */}
      <Modal
        isOpen={isGalleryModalOpen}
        onClose={closeGalleryModal}
        title={`Galeria de Fotos (${selectedImageIndex + 1}/${galeriaImages.length})`}
        maxWidth="6xl"
      >
        <div className="p-4">
          <Carousel
            className="w-full"
            opts={{
              startIndex: selectedImageIndex,
              align: "center",
              loop: galeriaImages.length > 1
            }}
          >
            <CarouselContent>
              {galeriaImages.map((image, index) => (
                <CarouselItem key={index}>
                  <div className="relative aspect-video w-full max-h-[70vh] bg-gray-100 rounded-lg overflow-hidden">
                    <Image
                      src={image.url}
                      alt={image.alt}
                      fill
                      className="object-contain"
                      sizes="90vw"
                      quality={95}
                    />
                  </div>
                  <div className="text-center mt-4 space-y-2">
                    <p className="text-gray-600">
                      {index + 1} de {galeriaImages.length}
                    </p>
                    <p className="text-sm text-gray-500 max-w-md mx-auto">
                      {image.alt}
                    </p>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious className="absolute left-4 top-1/2 bg-white/90 hover:bg-white shadow-lg" />
            <CarouselNext className="absolute right-4 top-1/2 bg-white/90 hover:bg-white shadow-lg" />
          </Carousel>
        </div>
      </Modal>

      {/* Navegação entre notícias */}
      <div className="mt-6 sm:mt-46 lg:mt-20 flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-6">
        {/* Botões de navegação */}
        <div className="flex justify-center items-center flex-1">
          {todasNoticiasNavegacao && todasNoticiasNavegacao.length > 0 && (() => {
            // Usar TODAS as notícias para navegação (destacadas ou não)
            const currentIndex = todasNoticiasNavegacao.findIndex((n: any) => n.documentId === noticiaData?.documentId);

            // Se a notícia atual não está no array, não mostrar navegação
            if (currentIndex === -1) {
              return null;
            }

            const hasPrevious = currentIndex > 0;
            const hasNext = currentIndex < todasNoticiasNavegacao.length - 1;
            const previousNoticia = hasPrevious ? todasNoticiasNavegacao[currentIndex - 1] : null;
            const nextNoticia = hasNext ? todasNoticiasNavegacao[currentIndex + 1] : null;

            return (
              <div className="flex gap-3">
                <button
                  onClick={() => {
                    if (previousNoticia) {
                      window.location.href = `/noticias-eventos/noticias/${previousNoticia.slug}`;
                    }
                  }}
                  disabled={!hasPrevious}
                  className={`px-6 py-2 rounded-full cursor-pointer border ${hasPrevious ? 'text-gray-500 border-gray-500 hover:text-greeniefp bg-white' : 'text-gray-300 border-gray-300 bg-white cursor-not-allowed'}`}
                  aria-label="Notícia anterior"
                >
                  Anterior
                </button>
                <button
                  onClick={() => {
                    if (nextNoticia) {
                      window.location.href = `/noticias-eventos/noticias/${nextNoticia.slug}`;
                    }
                  }}
                  disabled={!hasNext}
                  className={`px-6 py-2 rounded-full cursor-pointer border ${hasNext ? 'text-gray-500 border-gray-500 hover:text-greeniefp bg-white' : 'text-gray-300 border-gray-300 bg-white cursor-not-allowed'}`}
                  aria-label="Próxima notícia"
                >
                  Próximo
                </button>
              </div>
            );
          })()}
        </div>
      </div>
    </div>
  );
};

export default NoticiaDetalheClient;
